// Utility to get version from URL
export const getVersionFromUrl = (): string => {
  // Always return 'default' - URL parameters no longer supported
  return 'default';
};

// Get body style based on version
export const getBodyStyleForVersion = (version: string) => {
  const baseStyle = {
    fontFamily: "'Inter', sans-serif",
    color: '#1A202C',
    position: 'relative' as const,
    zIndex: 1
  };

  switch (version) {
    case '1':
    case '2':
    case '2.2':
    case '3':
    case '4':
    case '5':
      return {
        ...baseStyle,
        backgroundColor: 'transparent' // Let the canvas handle the background
      };
    default:
      // For production default, use transparent background to show V1 animation
      return {
        ...baseStyle,
        backgroundColor: 'transparent'
      };
  }
};